<div class="wrapper--spacing-horizontal" *ngIf="calculation">
  <div class="spacing--margin-top">
    <agr-summary-card
      [title]="'feed-profit.detail.baseline.properties-title' | translate"
      [canExpand]="false"
    >
      <form [formGroup]="form">
        <div class="flex--row flex--nowrap">
          <div class="flex--column spacing--padding-right">
            <span class="text--small text--bold label">
              {{ 'feed-profit.genders.label' | translate }}
            </span>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              class="formfield-outline"
              formControlName="genders"
              (selectionChange)="changeGenderSelection($event)"
              data-test="baseline__gender"
            >
              <mat-option *ngFor="let genderOption of genderOptions" [value]="genderOption">
                {{ 'feed-profit.genders.' + genderOption | translate }}
              </mat-option>
            </mat-select>
          </div>
          <div class="flex--column">
            <span class="text--small text--bold label">
              {{ 'feed-profit.country.label' | translate }}
            </span>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              class="formfield-outline"
              formControlName="country"
              (selectionChange)="changeCountrySelection($event)"
              data-test="baseline__country"
            >
              <mat-option value="">
                {{ 'feed-profit.detail.baseline.no-selection' | translate }}
              </mat-option>
              <mat-option *ngFor="let countryOption of countryOptions" [value]="countryOption">
                {{ 'feed-profit.country.' + countryOption | translate }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </form>
    </agr-summary-card>
  </div>
  <app-baseline-feeders
    [genders]="form.controls.genders.value"
    [isExtendedSimulation]="false"
    [calculation]="calculation"
    (feedersChanged)="updateFeeders($event)"
  ></app-baseline-feeders>
</div>
